import React, { useState } from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

export type SetStudentMessagingDisabledModalProps = {
  organizationId: string
  studentMessagingDisabled: boolean
}

const SetStudentMessagingDisabledModal: React.FC<
  SetStudentMessagingDisabledModalProps
> = ({ organizationId, studentMessagingDisabled }) => {
  const [error, setError] = useState<null | string>()
  const [, setStudentMessagingDisabled]: any[] = useMutation(
    setStudentMessagingDisabledMutation
  )

  const handleSubmit = closeModal => {
    setStudentMessagingDisabled({
      organizationId,
      value: !studentMessagingDisabled,
    })
      .then(
        result => {
          const { failures } = result.data.setStudentMessagingDisabled
          if (failures.length > 0) {
            setError(failures[0].message)
          } else {
            closeModal()
            NotificationManager.info("Student messaging will be updated")
          }
        },
        (e: Error) => setError(e.message)
      )
      .catch((e: Error) => setError(e.message))
  }

  const title = studentMessagingDisabled
    ? "Enable Student Messaging"
    : "Disable Student Messaging"

  return (
    <ModalWithProvidedBody
      modalTitle={title}
      buttonText={title}
      buttonClassName="btn btn-danger"
    >
      {({ closeModal }) => (
        <>
          <div className="modal-body">
            {studentMessagingDisabled ? (
              <p>
                Are you sure you want to enable messaging for all students in
                this Organization? Even students who previously had messaging
                disabled will have messaging enabled.
              </p>
            ) : (
              <p>
                Are you sure you want to disable messaging for all students in
                this Organization? There will be no record of the current
                students with messaging disabled.
              </p>
            )}
          </div>

          <div className="modal-footer flex-col">
            {error && <div className="alert alert-danger p-3">{error}</div>}
            <div className="flex w-full justify-between">
              <button
                type="button"
                onClick={closeModal}
                className="btn btn-info"
              >
                Cancel
              </button>
              <button
                type="submit"
                onClick={() => handleSubmit(closeModal)}
                className="btn btn-danger"
              >
                {studentMessagingDisabled
                  ? "Enable Messaging"
                  : "Disable Messaging"}
              </button>
            </div>
          </div>
        </>
      )}
    </ModalWithProvidedBody>
  )
}

const setStudentMessagingDisabledMutation = gql`
  mutation ($organizationId: ID!, $value: Boolean!) {
    setStudentMessagingDisabled(
      organizationId: $organizationId
      value: $value
    ) {
      failures {
        message
      }
    }
  }
`
export default SetStudentMessagingDisabledModal
